import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { TenantProvider } from '@/contexts/TenantContext';
import { loadStripe } from '@stripe/stripe-js';
import Impersonate from '@/components/Impersonate';
import TenantInitializer from '@/components/TenantInitializer';
import { ActionThemeSync } from '@/components/theme/ActionThemeSync';
import { ToastContainer } from 'react-toastify';
import { Elements } from '@stripe/react-stripe-js';
import { HelmetProvider } from 'react-helmet-async';
import AppRoutes from '@/routes/AppRoutes';

const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
);

function App() {
  return (
    <Elements
      stripe={stripePromise}
      options={{
        mode: 'setup',
        currency: 'aud',
        payment_method_types: ['card'],
        appearance: {
          theme: 'stripe',
        },
      }}
    >
      <HelmetProvider>
        <TenantProvider>
          <ActionThemeSync />
          <TenantInitializer>
            <ThemeProvider>
              <Impersonate />
              <ToastContainer position="bottom-left" hideProgressBar />
              <Router>
                <AuthProvider>
                  <AppRoutes />
                </AuthProvider>
              </Router>
            </ThemeProvider>
          </TenantInitializer>
        </TenantProvider>
      </HelmetProvider>
    </Elements>
  );
}

export default App;
